import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
var getEnvName = function getEnvName() {
  return getGlobalProperty("envName");
};
export var getIsProduction = function getIsProduction() {
  return getEnvName() === "production";
};